import React from "react";
import WishListSection from "../components/WishListSection";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

function WishlistPage() {
  return (
    <>
      <BreadcrumbTwo title="My Wishlist" />
      <WishListSection />
    </>
  );
}

export default WishlistPage;